import { useState, useEffect } from 'react';

export function FloatingCta() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // ページを少しスクロールしたら表示
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 transition-all duration-300 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="bg-white border-t-2 border-emerald-500 shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 py-3 sm:py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <div className="text-center sm:text-left">
              <div className="font-bold text-gray-900 text-sm sm:text-base">
                太陽光・蓄電池で電気代を大幅削減へ
              </div>
              <div className="text-xs sm:text-sm text-gray-600">
                まずは無料診断から始めませんか？
              </div>
            </div>
            <div className="flex items-center gap-3 w-full sm:w-auto">
              <button
                onClick={scrollToContact}
                className="flex-1 sm:flex-none bg-emerald-500 hover:bg-emerald-600 text-white px-6 py-3 rounded-lg font-bold text-sm transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-calculator-line mr-1"></i>
                無料診断
              </button>
              <a
                href="tel://0762553483"
                className="flex-1 sm:flex-none bg-white hover:bg-gray-50 text-emerald-600 px-6 py-3 rounded-lg font-bold text-sm transition-all duration-300 border-2 border-emerald-500 whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-1"></i>
                電話相談
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
